<template>
    <iframe 
        id="joinedClubPP" 
        class="iframeSel"
        :src="ruta" 
        @load="onLoad = true; $emit('resizeIframe'); $emit('changeLoadingStep', false);"
        :style="{ width: '100%', minHeight: `${windowHeight}px`, heigh: 'auto' }"
    ></iframe>
</template>

<script>
import { mapState } from 'vuex';

export default {
    data: () => ({
        oId: 0,
        uId: 0,
        token: '',
        windowHeight: 0,
        onLoad: false
    }),
    computed: {
        ...mapState({
            ruta(state) {
                let url = '/admin/joinclubpp?disOldSystem=true';
                if(this.oId && this.oId != 0) {
                    url = url + '&oId=' + this.oId;
                }
                    
                if(this.uId && this.uId != 0) {
                    url = url + '&uId=' + this.uId;
                }

                if(this.token && this.token != '') {
                    url = url + '&token=' + this.token;
                }
                
                return state.env.get('VUE_APP_ROOT') + url;
            },
            language(state) {
                return { languageId: state.session.languageId, languageCode: state.session.languageCode };
            }
        })
    },
    mounted() {
        this.oId = this.$route.query.oId;
        this.uId = this.$route.query.uId;
        this.token = this.$route.query.token;
        this.windowHeight = window.innerHeight;
    },
    watch: {
        language(val) {
            if(this.onLoad && val.languageId) 
                document.getElementById("joinedClubPP").contentWindow.updateLang(val.languageId);
        }
    }
}
</script>